<ng-template
    #validationMessages
    let-field="field"
>
    <!-- @if (shouldShowSuccess(field)) {
            <p
                class="mt-1 text-success text-sm"
                id="{{ getFieldId(field) }}-success"
                >Looks Good!</p
            >
        } -->
    @if (shouldShowError(field)) {
        <p
            class="mt-1 text-danger text-sm"
            id="{{ getFieldId(field) }}-error"
            >{{ getErrorMessage(field) }}</p
        >
    }
    @if (field.helpText) {
        <p
            class="mt-1 text-gray-500 dark:text-gray-400 text-sm"
            id="{{ getFieldId(field) }}-help"
            >{{ field.helpText }}</p
        >
    }
</ng-template>

<!-- Componentes reutilizáveis -->
<lc-form-edit-mode-header [editMode]="editMode" />
<lc-form-draft-indicator
    [hasDraft]="saveData"
    (onClearDraft)="resetForm()"
/>

<form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="space-y-6"
>
    <!-- Template reutilizável para campos -->
    <ng-template
        #fieldTemplate
        let-field="field"
    >
        @switch (field.type) {
            @case ('text') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="field.placeholder || field.label"
                        type="text"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('email') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="field.placeholder || 'seu@email.com'"
                        type="email"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('password') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <div class="relative">
                        <input
                            [id]="getFieldId(field)"
                            [formControlName]="field.name"
                            [placeholder]="field.placeholder || 'Digite sua senha'"
                            [type]="isPasswordVisible(field) ? 'text' : 'password'"
                            class="form-input w-full pr-10"
                            [readonly]="isFieldReadonly(field)"
                            [autocomplete]="getFieldAutocomplete(field)"
                            [attr.aria-label]="field.ariaLabel || field.label"
                            [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                            (input)="onFieldChange(field.name, $any($event.target).value)"
                        />
                        <button
                            type="button"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center max-w-9 mt-0"
                            style="margin-top: 0px"
                            (click)="togglePasswordVisibility(field)"
                            [attr.aria-label]="isPasswordVisible(field) ? 'Ocultar senha' : 'Mostrar senha'"
                        >
                            @if (isPasswordVisible(field)) {
                                <!-- Ícone de olho fechado (ocultar) -->
                                <svg
                                    class="h-5 w-5 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                                    ></path>
                                </svg>
                            } @else {
                                <!-- Ícone de olho aberto (mostrar) -->
                                <svg
                                    class="h-5 w-5 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    ></path>
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                    ></path>
                                </svg>
                            }
                        </button>
                    </div>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('phone') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="getMaskedPlaceholder(field)"
                        type="tel"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        [lcMask]="field.type"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case (isMaskedType(field)) {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="getMaskedPlaceholder(field)"
                        type="text"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        [lcMask]="field.type"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }

            @case ('number') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="getMaskedPlaceholder(field)"
                        type="number"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('date') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        type="date"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        (input)="onFieldChange(field.name, $any($event.target).value)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('time') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        type="time"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('datetime') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <input
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        type="datetime"
                        class="form-input w-full"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                    />
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('textarea') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <textarea
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        [placeholder]="field.placeholder || field.label"
                        class="form-input w-full"
                        rows="3"
                        [readonly]="isFieldReadonly(field)"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                    ></textarea>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('select') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <select
                        [id]="getFieldId(field)"
                        [formControlName]="field.name"
                        class="form-select w-full"
                        [ngClass]="{ readonly: isFieldReadonly(field) }"
                        [autocomplete]="getFieldAutocomplete(field)"
                        [attr.aria-label]="field.ariaLabel || field.label"
                        [attr.aria-describedby]="field.ariaDescribedBy || (field.helpText ? getFieldId(field) + '-help' : '')"
                        (change)="onFieldChange(field.name, $any($event.target).value)"
                    >
                        <option
                            value=""
                            [disabled]="field.required"
                        >
                            {{ field.placeholder || 'Selecione uma opção' }}
                        </option>
                        @for (option of field.options; track option.value) {
                            <option [value]="option.value">{{ option.label }}</option>
                        }
                    </select>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('radio') {
                <div [ngClass]="getFieldStatus(field)">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <div [ngClass]="field.layout === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                        @for (option of field.options; track option.value) {
                            <label class="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    [formControlName]="field.name"
                                    [value]="option.value"
                                    class="form-checkbox text-success"
                                    [autocomplete]="getFieldAutocomplete(field)"
                                    [attr.aria-label]="option.label"
                                />
                                <span class="text-gray-700 dark:text-gray-300">{{ option.label }}</span>
                            </label>
                        }
                    </div>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('switch') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500 ml-1">*</span>
                        }
                    </label>
                    <div class="flex items-center">
                        <label class="form-switch">
                            <input
                                [id]="getFieldId(field)"
                                [formControlName]="field.name"
                                type="checkbox"
                                [autocomplete]="getFieldAutocomplete(field)"
                                [attr.aria-label]="field.ariaLabel || field.label"
                            />
                            <span></span>
                        </label>
                    </div>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('checkbox') {
                <div [ngClass]="getFieldStatus(field)">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <div [ngClass]="field.layout === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                        @for (option of field.options; track option.value) {
                            <label class="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="checkbox"
                                    [checked]="isCheckboxSelected(field.name, option.value)"
                                    (change)="toggleCheckboxValue(field.name, option.value)"
                                    class="form-checkbox text-primary"
                                    [autocomplete]="getFieldAutocomplete(field)"
                                    [attr.aria-label]="option.label"
                                />
                                <span class="text-gray-700 dark:text-gray-300">{{ option.label }}</span>
                            </label>
                        }
                    </div>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
            @case ('file') {
                <div [ngClass]="getFieldStatus(field)">
                    <label
                        [for]="getFieldId(field)"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                    >
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <div class="file-upload-container">
                        <input
                            [id]="getFieldId(field)"
                            [formControlName]="field.name"
                            type="file"
                            [accept]="field.accept || '*'"
                            class="file-input"
                            (change)="onFileChange($event, field)"
                            [autocomplete]="getFieldAutocomplete(field)"
                            [attr.aria-label]="field.ariaLabel || field.label"
                        />
                        <div
                            class="file-drop-zone"
                            (click)="triggerFileInput(field.name)"
                            (dragover)="onDragOver($event)"
                            (drop)="onDrop($event, field)"
                        >
                            <div class="file-content">
                                <svg
                                    class="file-icon"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                    ></path>
                                </svg>
                                <p class="file-text"><span class="font-semibold">Clique para selecionar</span> ou arraste e solte</p>
                                <p class="file-hint">{{ field.placeholder || 'PDF, DOC, DOCX até 5MB' }}</p>
                            </div>
                        </div>
                        @if (getSelectedFile(field.name)) {
                            <div class="file-preview">
                                <div class="file-info">
                                    <svg
                                        class="file-preview-icon"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                        ></path>
                                    </svg>
                                    <div class="file-details">
                                        <p class="file-name">{{ getSelectedFile(field.name)?.name }}</p>
                                        <p class="file-size">{{ formatFileSize(getSelectedFile(field.name)?.size) }}</p>
                                    </div>
                                    <button
                                        type="button"
                                        class="file-remove"
                                        (click)="removeFile(field.name)"
                                    >
                                        <svg
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M6 18L18 6M6 6l12 12"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                    <ng-container *ngTemplateOutlet="validationMessages; context: { field: field }"></ng-container>
                </div>
            }
        }
    </ng-template>
    <!-- Template reutilizável para campos -->
    @for (group of getUniqueGroups(); track group) {
        @if (getFieldsetByGroup(group)) {
            <fieldset class="border-t border-t-gray-200 dark:border-t-gray-700 rounded-lg p-0 py-4">
                <legend class="text-lg font-semibold text-gray-900 dark:text-white text-center px-2">
                    {{ getFieldsetByGroup(group)?.title }}
                </legend>
                @if (getFieldsetByGroup(group)?.description) {
                    <p class="text-sm text-gray-600 dark:text-gray-400 mb-4 px-2">
                        {{ getFieldsetByGroup(group)?.description }}
                    </p>
                }
                <div class="grid grid-cols-12 gap-2">
                    @for (field of getFieldsByGroup(group); track field.name) {
                        @if (field.type !== 'button' && shouldShowField(field)) {
                            <div [ngStyle]="getFieldGridStyle(field)">
                                <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field }"></ng-container>
                            </div>
                        }
                    }
                </div>
            </fieldset>
        } @else {
            <div class="grid grid-cols-12 gap-4 pb-4">
                @for (field of getFieldsByGroup(group); track field.name) {
                    @if (field.type !== 'button' && shouldShowField(field)) {
                        <div [ngStyle]="getFieldGridStyle(field)">
                            <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field }"></ng-container>
                        </div>
                    }
                }
            </div>
        }
    }

    <!-- Componentes reutilizáveis -->
    <lc-form-error-message [error]="error" />
    <lc-form-loading-indicator [loading]="loading" />

    <!-- Botão de Submit -->
    @if (!(this.editMode.active && this.editMode.action === 'view')) {
        <lc-form-submit-button
            [buttonText]="submitButtonText"
            [loading]="loading"
            [disabled]="!isFormValid()"
            [color]="submitButtonColor || 'success'"
            (onSubmit)="onSubmit()"
        />
    }
</form>
@if (!(this.editMode.active && this.editMode.action === 'view')) {
    <!-- Footer informativo -->
    <lc-form-help-footer />
}
